import { useIsMutating } from '@tanstack/react-query';
import { useAuth } from '@/auth';
import { useDataProcessingStatusQuery } from '@/queries';
import { useAppSelector } from '@/redux';
import { getDataProcessingErrorMessage } from '@/services/dataProcessingApi';
import { queryKeys } from '@/services/queryKeys';
import { BATCH_JOB_STATUS, DATA_PROCESSING_POLL_INTERVAL_MS } from './constants';

/**
 * Current data processing job for the selected wave. Safe to call from any component
 * on the page: the jobId comes from Redux and React Query shares one status poll.
 */
export const useDataProcessingJob = () => {
  const { user } = useAuth();
  const jobId = useAppSelector((state) => state.wave.dataProcessingJobId);
  const statusQuery = useDataProcessingStatusQuery(jobId, user?.email, DATA_PROCESSING_POLL_INTERVAL_MS);
  const isStarting = useIsMutating({ mutationKey: queryKeys.startDataProcessing }) > 0;

  const job = statusQuery.data;

  return {
    jobId,
    job,
    // Covers the start request and the gap until the job reports a final status.
    isRunning: isStarting || (Boolean(jobId) && !job?.isComplete),
    isSucceeded: job?.status === BATCH_JOB_STATUS.SUCCEEDED,
    isFailed: job?.status === BATCH_JOB_STATUS.FAILED,
    lastCheckedAt: statusQuery.dataUpdatedAt,
    refreshError: statusQuery.isError ? getDataProcessingErrorMessage(statusQuery.error) : null,
  };
};
